{
  "title": "Pending transactions",
  "mode": {
    "title": "Inventory count mode",
    "on": "On",
    "off": "Off",
    "since": "Since {{time}} by {{name}}",
    "turnOn": "Turn on inventory count mode",
    "turnOff": "Turn off inventory count mode",
    "confirmOn": "Turn on inventory count mode for {{product}}?",
    "confirmOff": "Turn off inventory count mode for {{product}}?",
    "confirmDescription": "The change is recorded in the audit log with your name and the time.",
    "loadFailed": "Inventory count mode status could not be loaded"
  },
  "toolbar": {
    "searchLabel": "Number",
    "searchPlaceholder": "Search by number...",
    "postingStatus": "Posting status",
    "allStatuses": "All",
    "type": "Type",
    "allTypes": "All types",
    "product": "Product",
    "allProducts": "All products"
  },
  "type": {
    "PURCHASE": "Purchase",
    "SALE": "Cash sale",
    "DEBT_SALE": "Debt sale",
    "PAYMENT": "Payment",
    "RECEIPT": "Receipt"
  },
  "columns": {
    "number": "Number",
    "type": "Type",
    "product": "Product",
    "customer": "Customer",
    "barrels": "Total barrels",
    "jerrycans": "Total jerrycans",
    "finalTotal": "Final total",
    "completionStatus": "Completion status",
    "entryTime": "Entry time",
    "employee": "Employee",
    "completionEmployee": "Completion employee",
    "postingStatus": "Posting status",
    "postingTime": "Posting time",
    "postedBy": "Posted By",
    "businessDate": "Business date"
  },
  "completion": {
    "COMPLETED": "Completed",
    "AWAITING_PRICE": "Awaiting pricing"
  },
  "posting": {
    "PENDING": "Pending",
    "POSTED": "Posted"
  },
  "actions": {
    "view": "View",
    "completePrice": "Complete the price",
    "post": "Post"
  },
  "postConfirm": {
    "title": "Post transaction {{reference}}?",
    "number": "Transaction number",
    "entryTime": "Entry time",
    "businessDate": "Business date it goes to",
    "loading": "Loading...",
    "modeActive": "Inventory count mode is on: the transaction will be added to the shift being counted.",
    "forceConfirm": "I confirm forcing this transaction into the shift being counted",
    "force": "Force post"
  },
  "toast": {
    "posted": "Transaction posted to the business date {{date}}"
  },
  "empty": {
    "noData": "No pending transactions",
    "noResults": "No results"
  },
  "forced": "Forced post",
  "bulk": {
    "action": "Post selected",
    "selectAll": "Select all",
    "selectRow": "Select transaction {{reference}}",
    "selectedLabel": "Selected: {{count}}",
    "selectHint": "Select at least one pending transaction to post it.",
    "title": "Post the selected transactions",
    "selectedCount": "Selected transactions",
    "eligibleCount": "Ready to post",
    "groupDate": "Will be posted to business date",
    "groupCount": "Count: {{count}}",
    "refusedTitle": "These transactions will not be posted and stay pending:",
    "noneEligible": "None of the selected transactions can be posted now.",
    "modeActive": "Inventory count mode is on: the transactions will be added to the shift being counted now.",
    "forceConfirm": "I confirm forcing these transactions into the shift being counted",
    "resultTitle": "Posting result",
    "postedCount": "Posted",
    "failedCount": "Not posted",
    "failedTitle": "These transactions stay pending:",
    "toastPosted": "Posted the selected transactions: {{count}}"
  }
}
